import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  width: fit-content;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
var StepperWrapper = styled.div.withConfig({
    componentId: "sc-aff90cdd-0"
})(_templateObject());
var Stepper = function(param) {
    var children = param.children;
    var numberOfSteps = React.Children.count(children);
    return /*#__PURE__*/ _jsx(StepperWrapper, {
        children: React.Children.map(children, function(child) {
            if (/*#__PURE__*/ React.isValidElement(child)) {
                return /*#__PURE__*/ React.cloneElement(child, {
                    numberOfSteps: numberOfSteps
                });
            }
            return child;
        })
    });
};
export default Stepper;
